import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import { List, Dialog } from 'antd-mobile'
const PageModel = props => {
	const [list, setList] = useState([]);
	const [imei, setImei] = useState('');

	console.log(props.location.state);
	

	const getList = async () => {
		const result = await Request.get({
			url: '/company/list'
		});
		if (!result) return;

		const list = result.data.list || [];
		setList(list);
	};
	
	useEffect(() => {
		setImei(props.location.state.imei);
		//获取企业列表
		getList()
	}, [imei]);

	const postdata = (item) => {
		console.log('公司id',item.id);
		console.log('设备',imei);
		Dialog.confirm({
			content: '确定将该设备'+imei+'绑定到'+item.companyName+'吗？',
			onConfirm: async () => {
				Request.post({
					url: '/company/bind',
					data: {	
						companyId: item.id,
						equipmentImei: imei
					}	
				}).then(res => {
					console.log(res);
					if (res.ok === 0) {
						window.history.back(-1);
					}
				}).catch(err => {
					console.log(err);
				});
			},
		})
	}

	return (
		<List header='所有企业列表'>
			{list.length > 0 && list.map((item, index) => {
				return (
					<List.Item disabled={item.equipmentlist.length > 0} extra={item.equipmentlist.length > 0? '已绑定设备' : ''} key={index} onClick={() => {	
						postdata(item)
					}}>{item.companyName}</List.Item>
				)
			})
			}

		</List>
	);
};

export default PageModel;
